export default __webpack_public_path__ + "static/media/f-09.15f6e949.jpg";